import { apiGet, apiPost } from './client.js';

export const login = ({ email, password }) => apiPost('/auth/login', { email, password });
export const logout = () => apiPost('/auth/logout', {});
export const validateResetToken = (token) => apiGet(`/auth/validate-token?token=${encodeURIComponent(token)}`);
export const setPassword = ({ token, password }) => apiPost('/auth/set-password', { token, password });
